<script setup lang="ts">
import { computed } from 'vue'
import { levelLightBackgroundClass, levelLightBackgroundTextClass, levelSolidBackgroundClass, type ObjectiveLevel } from './objective_levels'

const props = withDefaults(
  defineProps<{
    level: ObjectiveLevel
    title: string
    isQuarterShown?: boolean
    titleId?: string
  }>(),
  { isQuarterShown: true, titleId: undefined }
)

const displayedTitle = computed(() => props.title || 'Objective')

const headingClasses = computed(() => {
  if (props.isQuarterShown) {
    return ['rounded-t-xs', levelLightBackgroundClass(props.level)]
  }
  return ['px-4 py-3', levelSolidBackgroundClass(props.level)]
})

const titleClasses = computed(() => {
  if (props.isQuarterShown) {
    return ['pl-3', levelLightBackgroundTextClass(props.level)]
  }
  return 'pl-px text-white'
})
</script>

<template>
  <div class="relative flex items-center overflow-hidden" :class="headingClasses" data-testid="objective-heading">
    <div
      v-if="isQuarterShown"
      class="min-w-20 flex-none self-stretch px-4 py-2 leading-5 tracking-wide text-white"
      :class="levelSolidBackgroundClass(level)"
      data-testid="objective-heading-quarter"
    >
      <b class="text-text-2xl font-medium">{{ level }}</b>
      <br>
      <span class="text-text-sm font-regular">Quarter</span>
    </div>
    <h3
      :id="titleId"
      class="m-0 flex-auto truncate pb-1 text-text-xl font-bold leading-none"
      :class="titleClasses"
      :title="title"
    >
      {{ displayedTitle }}
    </h3>
    <div class="flex-auto whitespace-nowrap pr-6 text-right">
      <slot name="actions" />
    </div>
  </div>
</template>
